import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useCategoryCounts() {
  return useQuery({
    queryKey: ["category-counts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("products")
        .select("categories")
        .neq("type", "variation")
        .eq("published", true);
      if (error) throw error;

      const counts = new Map<string, number>();
      data.forEach((p) => {
        if (p.categories) {
          p.categories.split(",").forEach((c) => {
            const trimmed = c.trim().split(">").pop()?.trim();
            if (trimmed) counts.set(trimmed, (counts.get(trimmed) || 0) + 1);
          });
        }
      });
      return counts;
    },
  });
}
